import axios from "axios"; //引用axios
import { Promise } from "es6-promise";

// axios 动态配置 在App.vue中
// axios.defaults.timeout = 5000;
// axios.defaults.baseURL = 'http://10.0.99.246:9000/api/';
// http request 拦截器，通过这个，我们就可以把Cookie传到后台
// axios.interceptors.request.use(
//     config => {
//         config.headers = {
//             'Content-Type': 'application/json' //设置跨域头部
//         };
//         return config;
//     },
//     err => {
//         return Promise.reject(err);
//     }
// );

// http response 拦截器
// axios.interceptors.response.use(
//     response => {
//         return response;
//     });

// export default axios;

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch(
  url,
  params = {},
  headers = {
    "Content-Type": "application/json", //设置跨域头部
    Authorization: "JWT " + sessionStorage.getItem("authToken")
  }
) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: headers
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err.response);
      });
  });
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(
  url,
  data = {},
  config = {
    headers: {
      "Content-Type": "application/json", //设置跨域头部
      Authorization: "JWT " + sessionStorage.getItem("authToken")
    }
  }
) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err.response);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/util/http.js